<template>

  <router-view></router-view>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      class: 'none'
    }
  },
  mounted () {
  },
  methods: {
  },
  watch: {
    $route (to, from) {
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app.vue